import { render } from "./iconSelector.vue?vue&type=template&id=20a8685a&scoped=true&ts=true"
import script from "./iconSelector.vue?vue&type=script&lang=ts"
export * from "./iconSelector.vue?vue&type=script&lang=ts"

import "./iconSelector.vue?vue&type=style&index=0&id=20a8685a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a8685a"]])

export default __exports__